import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { ViewBookingViewModeEnum } from 'src/app/models/enums/ViewBooking/ViewBookingEnum';
import { ObjPayment } from './../../../models/Booking/ReservationSaveAndConfirmModel';
import { SearchSectionService } from './../../../services/searchSection.service';
import { Vehicle } from 'src/app/models/Vehicle';
import { SearchService } from './../../../services/search.service';
import { Component, EventEmitter, Output, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { ThemePalette } from '@angular/material/core';
import { VehicleReservationSearchParm } from './../../../models/VehicleReservationSearchParm';
import { DateFormatPipe } from './../../../common/pipes/DateFormatPipe';
import { VehicleReservationCaseResult } from 'src/app/models/Booking/VehicleReservationCaseResult';
import { DropUpLocaionModel } from 'src/app/models/DropUpLocaionModel';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Router } from '@angular/router';
import { ViewBookingBaseComponent } from 'src/app/views/booking/view-booking-base/view-booking-base.component'
import { IconService } from './../../../services/icon.service';
import { BehaviorSubject } from 'rxjs';
import { NotAvailableReasonEnum } from '../extend-rental-time-modal/extend-rental-time-modal.component';
import { ModeType } from 'src/app/models/enums/BookingEnums';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import 'moment/locale/ar';
import { NotificationsService } from 'angular2-notifications';


declare var $: any;
declare const svgToUrlImage: any;
declare const myTest: any;

@Component({
  selector: 'modify-pickup-modal',
  templateUrl: './modify-pickup-modal.component.html',
  styleUrls: ['./modify-pickup-modal.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class ModifyPickupModalComponent extends ViewBookingBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  selectedLang: any;
  @Output() onCancel = new EventEmitter();

  faTimesCircle = faTimesCircle;
  searchForm: FormGroup;
  submitted = false;

  minPickUpDate: any = new Date();
  minDropOffDate: any;
  minTime: any;

  viewBooking: ViewBookingModel;

  //Slide toggle
  color: ThemePalette = 'accent';
  checked = false;
  disabled = false;
  manualUpdate: boolean;
  faClock = faClock;
  vehicle: Vehicle;
  currency;
  duration;
  success;
  notAvailable = true;
  vehicleReservationCaseResult: VehicleReservationCaseResult;
  dropUpLocations: DropUpLocaionModel[];
  selectedDropUpLocation;
  caseID;
  gracePeriod: any;
  minDroppOffTime: string;
  newDurationData;
  needPayment: boolean;
  requiredPayment: any;
  objPayment: ObjPayment;
  resultMsg: any = "BookedRentalisNotAvailable";

  viewBookingViewMode = ViewBookingViewModeEnum.ModifyPickUp;
  result: any;
  notAvailableReason: NotAvailableReasonEnum;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private matIconRegistry: MatIconRegistry,
    protected cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private bookingService: BookingService,
    //private dialogRef: MatDialogRef<ModifyPickupModalComponent>,
    //@Inject(MAT_DIALOG_DATA) data,
    private domSanitizer: DomSanitizer,
    private authService: AuthService,
    public translateService: TranslateService,
    private _dateFormatPipe: DateFormatPipe,
    private searchSectionService: SearchSectionService,
    private iconService: IconService,
    private translate: TranslateService,
    private _notifications: NotificationsService,
    private _adapter: DateAdapter<any>) {
    super(iconService, domSanitizer, matIconRegistry);
    //this.vehicle = searchService.getVehicle();
    this.currency = searchService.getCurrency();

    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.matIconRegistry.addSvgIcon(
      "timeIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );

  }
  ngOnDestroy(): void {

    this.newDurationData.next(null);

  }

  ngOnInit() {
    this.newDurationData = new BehaviorSubject(null);

    this.bookingService.vehicleReservationCaseResult.subscribe(res => {
      this.vehicleReservationCaseResult = res;

      //Deep Copy of the response
      let copiedItem = {};
      copiedItem = Object.assign({}, copiedItem, res);
      let _viewBooking = this.bookingService.reservationCaseToViewBookingModel(copiedItem as VehicleReservationCaseResult);
      this.viewBooking = _viewBooking;

      let pickUpDate = new Date();
      let dropOffDate = new Date();
      if (this.vehicleReservationCaseResult != null) {

        pickUpDate = new Date(this.vehicleReservationCaseResult.startDate);
        dropOffDate = new Date(this.vehicleReservationCaseResult.endDate);
        this.minDropOffDate = new Date(this.vehicleReservationCaseResult.startDate);
        this.searchForm = this.formBuilder.group({
          PickUpLocation: [this.vehicleReservationCaseResult.fromAgencyName, Validators.required],
          PickUpDate: [new Date(this.vehicleReservationCaseResult.startDate), Validators.required],
          PickUpTime: [this.vehicleReservationCaseResult.startTimeString, Validators.required],
          dropUpDate: [new Date(this.vehicleReservationCaseResult.endDate), Validators.required],
          dropUpTime: [this.vehicleReservationCaseResult.endTimeString, Validators.required],
          DropUpLocation: [{ value: this.vehicleReservationCaseResult.dropOffLocationID, disabled: true }, Validators.required],
        });

      }
      else {
        //Todo: show something went wrong or some handling
        //For now:
        this.searchForm = this.formBuilder.group({
          PickUpLocation: ['', Validators.required],
          PickUpDate: ['', Validators.required],
          PickUpTime: ['', Validators.required],
          dropUpDate: ['', Validators.required],
          dropUpTime: ['', Validators.required],
          DropUpLocation: ['', Validators.required],
        });
      }

      let scopeMinTime;

      this.searchService.reservationSettings().subscribe(res => {
        let gracePeriod = 0;
        if (res != null) {
          gracePeriod = res.bookingGracePeriodSettings.bookingGracePeriodInHours;
        }
        //this.gracePeriod = gracePeriod;
        this.gracePeriod = 0;
        scopeMinTime = this.searchService.getFirstValidSartTime(new Date(), gracePeriod); //For the Jquery,
        this.minDroppOffTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Place holder in html

        this.minPickUpDate = this.searchService.getFirstValidSartDate(new Date(), this.gracePeriod);
        //Get the first available time to book a car Today
        this.minTime = this.searchService.getFirstValidSartTime(new Date(), gracePeriod);
        let currentDateMinTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Jquery,
        let scopeMinDroppOffTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Place holder in html
        scopeMinTime = this.searchService.getFirstValidSartTime(new Date(), this.gracePeriod); //For the Jquery,

        const component = this;
        $(document).ready(function () {

          component.initTimePicker();



        });
      })

      // this.searchService.getDropUpLocationsByAgencyID(this.vehicleReservationCaseResult.agencyID, 'en',false,this.vehicleReservationCaseResult.classID,this.vehicleReservationCaseResult.makeID,this.vehicleReservationCaseResult.modelID,this.vehicleReservationCaseResult.year,this.vehicleReservationCaseResult.vehicleID).subscribe(res => {
      //   //this.dropUpLocations = res;
      // });

      this.bookingService.vehicle.subscribe(res => {

        this.vehicle = res;
        // this.bookingService.getOneWayRentalLocaions(this.vehicleReservationCaseResult.agencyID, this.viewBooking.oneWayRentalModel.returnAgencyID, ModeType.Edit, this.viewBooking.oneWayRentalModel.isTaxsable, this.vehicle.classID, this.vehicle.makeID, this.vehicle.modelID, this.vehicle.year, this.vehicle.vehicleID, false)
        //   .subscribe(res => {
        //     this.dropUpLocations = res;
        //   });
        if (this.vehicle != null) {
          this.searchService.getDropUpLocationsByAgencyID(this.vehicleReservationCaseResult.agencyID, 'en', false, this.vehicle.classID, this.vehicle.makeID, this.vehicle.modelID, this.vehicle.year, this.vehicle.vehicleID)
          .subscribe(res => {
            if (res != null) {
              this.dropUpLocations = res.filter(a => a.returnAgencyID == this.vehicleReservationCaseResult.dropOffLocationID)
            }
          });
        }

      });



    });


    // This is For changing language for the calendar
    this.selectedLang = JSON.parse(localStorage.getItem("lang"));
    switch (this.selectedLang.isoCode2) {
      case "en":
        this._adapter.setLocale('en-US');
        break;
      case "ar":
        this._adapter.setLocale('ar-ly');
        break;
      default:
        this._adapter.setLocale('en-US');
        break;
    }






  }
  ngAfterViewInit() {

    
    this.attachListenerTimePicker();

  }

  initTimePicker() {
    //Initilize the Time Picker for pick up and drop off
    $('#pickUpTime').timepicker({ 'step': 15, 'minTime': '12:00am', 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });
    $('#dropUpTime').timepicker({ 'step': 15, 'minTime': '12:00am', 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });
  }

  attachListenerTimePicker() {
    //Attach onChange Event
    $('#pickUpTime').on('changeTime', (e, dateText) => {

      this.searchForm.controls.PickUpTime.setValue($(e.target).val());
      //Check IF PickUp Time is greater than DropOff
      //this.validateDropOffTimeBasedOnPickUp($(e.target).val());
    });
    $('#dropUpTime').on('changeTime', (e, dateText) => {

      this.searchForm.controls.dropUpTime.setValue($(e.target).val());
      //this.searchForm.controls.PickUpTime.setValue(dateText);
    });
  }

  /** Validate DropOffTime Based on PickUpTime*/
  validateDropOffTimeBasedOnPickUp(pickUpTime: string) {

    let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
    let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);

    //IF They are on the same day, then we need to check
    //If the picktime greater than DropOff
    if (pickUpDate.getDate() == dropOffDate.getDate()) {
      let dropOffTime = this.searchForm.controls.dropUpTime.value;
      let compareResult = this.searchSectionService.comparePickUpAndDropOffTime(pickUpTime, dropOffTime);
      //If PickUp Is Greater than dropOff , then we will validate dropOff
      if (compareResult == 1) {
        $('#dropUpTime').timepicker('option', 'minTime', pickUpTime);
        this.searchForm.controls.dropUpTime.setValue(pickUpTime);
      }
    }

  }


  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }

  get NotAvailableReasonEnum() {
    return NotAvailableReasonEnum;
  }

  onSubmit() {

    this.searchForm.controls;
    ;


    this.submitted = true;
    this.notAvailable = false;
    this.success = null;
    // stop here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    if (this.searchForm.controls["PickUpTime"].value > this.searchForm.controls["dropUpTime"].value && this.searchForm.controls["PickUpDate"].value == this.searchForm.controls["dropUpDate"].value) {

      this.translate.get('DropOffShouldbegreaterthanPickUp').subscribe(res => {
        this.showWarnNotification(res);
      })
      return;
    }


    let req = this.getCheckAvailabilityRequest();



    let StartDate = new Date(this.searchForm.value['PickUpDate']);
    let StartTimeString = this.searchForm.controls["PickUpTime"].value;

    let EndDate = new Date(this.searchForm.value['dropUpDate']);
    let EndTimeString = this.searchForm.controls["dropUpTime"].value;

    if (!this.searchService.validateDropOffVSPickUp(StartDate, StartTimeString, EndDate, EndTimeString)) {
      this.translate.get('DropOffShouldbegreaterthanPickUp').subscribe(res => {
        this._notifications.warn("<span>" + res + "</span>", null, {
          timeOut: 30000,
          showProgressBar: false,
          pauseOnHover: true,
          clickToClose: true,
          fade: true,
          actions: [{
            action: "Allow",
          }],
          icons: {
            error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
            warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
          }
        });
      })
      return;

    }


    if (this.checkIFSameAsPreviousOne(this.vehicleReservationCaseResult, req)) {
      this.translate.get('YouShouldChangeTheDate').subscribe(res => {
        this.showWarnNotification(res);
      })
      return;
    }
    this.bookingService.checkReservationCaseAvailability(req).subscribe(res => {

      this.result = res;
      if (this.result.unavailableAdditional) {
        this.notAvailable = true;
        this.notAvailableReason = NotAvailableReasonEnum.UnavailableAdditional;
        //this.unavailableAditionalServiceData.next(this.result.lstUnavailableAdditionalServiceReservationCaseModel);
      }
      else if (res != null && res.isAvailable) {

        this.newDurationData.next(res);
        this.success = true;
      }
      else {
        this.resultMsg = res.msg;
        this.success = false;
      }

    }, err => this.success = false);



  }
  showWarnNotification(res: any) {
    this._notifications.warn("<span>" + res + "</span>", null, {
      timeOut: 30000,
      showProgressBar: false,
      pauseOnHover: true,
      clickToClose: true,
      fade: true,
      actions: [{
        action: "Allow",
      }],
      icons: {
        error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
        warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
      }
    })
  }

  checkIFSameAsPreviousOne(vehicleReservationCaseResult: VehicleReservationCaseResult, req: VehicleReservationSearchParm) {
    if (vehicleReservationCaseResult.startDateString == req.StartDateString
      && vehicleReservationCaseResult.startTimeString == req.StartTimeString
      && vehicleReservationCaseResult.endDateString == req.EndDateString
      && vehicleReservationCaseResult.endTimeString == req.EndTimeString) {
      return true;
    }
    return false;
  }

  getCheckAvailabilityRequest() {
    //let dropUpLocation = this.searchForm.value['DropUpLocation'] as DropUpLocaionModel;
    let returnAgencyID = this.searchForm.value['DropUpLocation'];
    let dropOffLocationTypeID = null;
    let returnAgency = this.dropUpLocations.filter(a => a.returnAgencyID == returnAgencyID)[0];
    if (returnAgency != null) {
      dropOffLocationTypeID = returnAgency.agencyReturnLocationTypeID;
    }

    let req: VehicleReservationSearchParm = {
      StartDateString: this._dateFormatPipe.transform(this.searchForm.value['PickUpDate']),
      //StartDate: this.searchForm.value['PickUpDate'],
      StartTimeString: this.searchForm.value['PickUpTime'],
      EndDateString: this._dateFormatPipe.transform(this.searchForm.value['dropUpDate']),
      //EndDate: this.searchForm.value['dropUpDate'],
      EndTimeString: this.searchForm.value['dropUpTime'],
      ToAgencyID: this.vehicleReservationCaseResult.dropOffLocationID,
      FromAgencyID: this.vehicleReservationCaseResult.agencyID,
      AgencyID: this.vehicleReservationCaseResult.agencyID,
      CaseID: this.vehicleReservationCaseResult.caseID,
      ClassID: this.vehicle.classID,
      VehicleID: this.vehicle.vehicleID,
      MakeID: this.vehicle.makeID,
      ModelID: this.vehicle.modelID,
      Year: this.vehicle.year,
      DropOffLocationTypeID: this.vehicleReservationCaseResult.dropOffLocationTypeID,
      ContractTypeID: this.vehicleReservationCaseResult.contractTypeID
    };
    return req;
  }


  close(): void {
    //this.dialogRef.close();
  }
  closeOnUpdate() {
    // this.dialogRef.close(true);
  }

  /*   //Event handler when pickup datepicker changed
    addEvent(mode: number, type: string, event: MatDatepickerInputEvent<Date>) {


      //PickUp Date

      if (mode == 1) {
        let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);
        this.minDropOffDate = new Date(event.value);
        if (new Date(event.value).getDate() == new Date().getDate() && new Date(event.value).getDate() == dropOffDate.getDate()) {

          $('#pickUpTime').timepicker('option', 'minTime', this.minTime);
          this.searchForm.controls.PickUpTime.setValue(this.minTime);
          $('#dropUpTime').timepicker('option', 'minTime', this.minDroppOffTime);
          this.searchForm.controls.dropUpTime.setValue(this.minDroppOffTime);
        }
        else if (new Date(event.value).getDate() == new Date().getDate()) {
          $('#pickUpTime').timepicker('option', 'minTime', this.minTime);
          this.searchForm.controls.PickUpTime.setValue(this.minTime);
        }
        else {
          if (new Date(event.value).getDate() == dropOffDate.getDate()) {
            $('#pickUpTime').timepicker('option', 'minTime', '12:00am');
            let pickUpTime = this.searchForm.controls.PickUpTime.value;
            $('#dropUpTime').timepicker('option', 'minTime', pickUpTime);
            this.searchForm.controls.dropUpTime.setValue(pickUpTime);
          }
          //IF PickUp Date Greter than drop OFF
          else if (new Date(event.value) > dropOffDate) {
            this.searchForm.controls.dropUpDate.setValue(new Date(event.value));
            let pickUpTime = this.searchForm.controls.PickUpTime.value;
            let dropUpTime = this.searchForm.controls.dropUpTime.value;
            if (!this.searchService.validateTime(dropUpTime, pickUpTime)) {
              $('#dropUpTime').timepicker('option', 'minTime', pickUpTime);
              this.searchForm.controls.dropUpTime.setValue(pickUpTime);
            }
          }
          else {
            $('#pickUpTime').timepicker('option', 'minTime', '12:00am');
            $('#dropUpTime').timepicker('option', 'minTime', '12:00am');
          }
        }

      }
      //Drop Off Date
      else if (mode == 2) {
        let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
        if (new Date(event.value).getDate() == pickUpDate.getDate()) {
          let pickUpTime = this.searchForm.controls.PickUpTime.value;
          $('#dropUpTime').timepicker('option', 'minTime', pickUpTime);
          this.searchForm.controls.dropUpTime.setValue(pickUpTime);
        }
        else {
          $('#dropUpTime').timepicker('option', 'minTime', '12:00am');

        }
      }
      this.ngAfterViewInit();



    } */


  //Event handler when pickup datepicker changed
  addEvent(mode: number, type: string, event: MatDatepickerInputEvent<Date>) {


    //PickUp Date

    if (mode == 1) {
      let dropOffDate = new Date(this.searchForm.controls.dropUpDate.value);
      this.minDropOffDate = new Date(event.value);
      if (new Date(event.value).getDate() == new Date().getDate() && new Date(event.value).getDate() == dropOffDate.getDate()) {


        this.searchForm.controls.PickUpTime.setValue(this.minTime);

        //this.searchForm.controls.dropUpTime.setValue(this.minDroppOffTime);
      }
      else if (new Date(event.value).getDate() == new Date().getDate()) {

        this.searchForm.controls.PickUpTime.setValue(this.minTime);
      }
      else {
        if (new Date(event.value).getDate() == dropOffDate.getDate()) {

          let pickUpTime = this.searchForm.controls.PickUpTime.value;

          this.searchForm.controls.dropUpTime.setValue(pickUpTime);
        }
        //IF PickUp Date Greter than drop OFF
        else if (new Date(event.value) > dropOffDate) {
          this.searchForm.controls.dropUpDate.setValue(new Date(event.value));
          let pickUpTime = this.searchForm.controls.PickUpTime.value;
          let dropUpTime = this.searchForm.controls.dropUpTime.value;
          if (!this.searchService.validateTime(dropUpTime, pickUpTime)) {

            this.searchForm.controls.dropUpTime.setValue(pickUpTime);
          }
        }
        else {

        }
      }

    }
    //Drop Off Date
    else if (mode == 2) {
      let pickUpDate = new Date(this.searchForm.controls.PickUpDate.value);
      if (new Date(event.value).getDate() == pickUpDate.getDate()) {
        let pickUpTime = this.searchForm.controls.PickUpTime.value;

        //this.searchForm.controls.dropUpTime.setValue(pickUpTime);
      }
      else {


      }
    }
    this.ngAfterViewInit();



  }
  onConfirm() {


    let req = this.getCheckAvailabilityRequest();


    this.bookingService.updateConfirmedRentalPeriod(req).subscribe(res => {


      if (res != null) {
        if (res["needPayment"]) {
          this.needPayment = true;
          this.requiredPayment = res["requiredPayment"];
          this.objPayment = res["objPayment"];
        }
        else {
          this.closeOnUpdate();
          this.bookingService.updateViewBookingState();
          this.onCancel.emit(true);
          this.ngOnDestroy();
        }

      }
    })

  }

  changeViewType() {
    this.submitted = false;
    this.needPayment = false;

  }

  cancelClicked() {
    this.onCancel.emit(true);
    this.ngOnDestroy();
  }

}
